import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { AddTemplate } from "../../Redux/WhatsappSlice/Template";

const Add_Template = () => {
  const dispatch = useDispatch();

  // const { TemplateData } = useSelector((state) => state.Template);

  //   useEffect(() => {
  //     dispatch(fetchVersions());
  //     dispatch(fetchProjects());
  //   }, [dispatch]);

  const [formData, setFormData] = useState({
    FormatID: "",
    Script: "",
    TemplateName: "",
    TemplateJson: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.FormatID) newErrors.FormatID = "Format ID is required.";
    if (!formData.TemplateJson)
      newErrors.TemplateJson = "Template Json is required.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        await dispatch(AddTemplate({ values: formData })).unwrap();

        toast.success("Template added successfully!", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
        });

        // Reset form
        setFormData({
          FormatID: "",
          Script: "",
          TemplateName: "",
          TemplateJson: "",
        });
        // dispatch(fetchVersions());
      } catch (error) {
        toast.error(
          `Failed to add Template: ${error.message || "Unknown error"}`,
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
          }
        );
      }
    } else {
      toast.error("Please fix validation errors.", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            Add Template
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
          <form onSubmit={handleSubmit} className="grid grid-cols-12 gap-4 p-4">
            {/* Format ID Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Format ID</h5>
              <input
                type="text"
                name="FormatID"
                placeholder="Enter version number"
                value={formData.FormatID}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.FormatID && (
                <p className="text-red-500 text-sm mt-1">{errors.FormatID}</p>
              )}
            </div>

            {/* Script Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Script</h5>
              <input
                type="text"
                name="Script"
                placeholder="Enter version number"
                value={formData.Script}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
            </div>

            {/* Template Name Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Template Name</h5>
              <input
                type="text"
                name="TemplateName"
                placeholder="Enter version number"
                value={formData.TemplateName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
            </div>

            {/* Template JSON Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Template JSON </h5>
              <input
                type="text"
                name="TemplateJson"
                placeholder="Enter version number"
                value={formData.TemplateJson}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.TemplateJson && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.TemplateJson}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <div className="submit_Form col-span-12 flex justify-center">
              <button type="submit" className="All_button">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Add_Template;
